import store from '@/store';
import cryptoCurrency from '@/store/modules/cryptoCurrency';
import { registerModuleOnce } from '@/store/registerModulesOnce';

registerModuleOnce('cryptoCurrency', cryptoCurrency);

export default store;
